import React from 'react';
import { HiredProfiles } from '../Pages/HiredProfiles/HiredProfiles';

function HiredProfilesPage() {
  return (
    <>
      <HiredProfiles />
    </>
  );
}

export default HiredProfilesPage;

